export default __webpack_public_path__ + "static/media/thankyou-check.45f1a284.svg";